import { render, staticRenderFns } from "./accountsManage.vue?vue&type=template&id=08ad4022&scoped=true"
import script from "./accountsManage.vue?vue&type=script&lang=js"
export * from "./accountsManage.vue?vue&type=script&lang=js"
import style0 from "./accountsManage.vue?vue&type=style&index=0&id=08ad4022&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ad4022",
  null
  
)

export default component.exports